<template>
	<v-hover>
		<template>
			<v-btn
				class="botao-cancelar my-2 my-lg-0 my-md-0 my-sm-0 text-capitalize"
				:class="{ 'botao-cancelar__tamanho-largura': !tamanhoLargura }"
				:style="{ width: tamanhoLargura + 'px' }"
				outlined
				dense
				:block="block"
				:disabled="disabled"
				@click="trataAcaoDeBotaoDesabilitado(() => $emit('cancelar'))"
			>
				<div>
					{{ label }}
				</div>
			</v-btn>
		</template>
	</v-hover>
</template>

<script>
import trataAcaoDeBotaoDesabilitado from '@/views/mixins/trataAcaoDeBotaoDesabilitado'

export default {
	name: 'botao-cancelar',
	mixins: [trataAcaoDeBotaoDesabilitado],
	props: {
		label: {
			type: String,
			default: 'CANCELAR',
		},
		block: {
			type: Boolean,
		},
		tamanhoLargura: {
			type: String,
			default: null,
		},
	},
}
</script>

<style lang="stylus">
.botao-cancelar
	color #c2c2c2 !important
	font-size (13 / 16)rem !important

	&__tamanho-largura
		min-width 6.25rem !important;
</style>
